import { render } from "./warningDetail.vue?vue&type=template&id=b605d5f4&scoped=true"
import script from "./warningDetail.vue?vue&type=script&lang=js"
export * from "./warningDetail.vue?vue&type=script&lang=js"

import "./warningDetail.vue?vue&type=style&index=0&id=b605d5f4&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b605d5f4"]])

export default __exports__